import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';

export class FinancialAccountTransactionMeta extends BaseEntityModel {
  category?: string[];
  address?: string;
  city?: string;
  region?: string;
  postalCode?: string;
  country?: string;
  lat?: number;
  lon?: number;
  storeNumber?: string;
  byOrderOf?: string;
  payee?: string;
  payer?: string;
  paymentMethod?: string;
  paymentProcessor?: string;
  ppdId?: string;
  reason?: string;
  referenceNumber?: string;

  constructor(model: Partial<FinancialAccountTransactionMeta> = {}) {
    super(model);

    this.category = model.category;
    this.address = model.address;
    this.city = model.city;
    this.region = model.region;
    this.postalCode = model.postalCode;
    this.country = model.country;
    this.lat = model.lat;
    this.lon = model.lon;
    this.storeNumber = model.storeNumber;
    this.byOrderOf = model.byOrderOf;
    this.payee = model.payee;
    this.payer = model.payer;
    this.paymentMethod = model.paymentMethod;
    this.paymentProcessor = model.paymentProcessor;
    this.ppdId = model.ppdId;
    this.reason = model.reason;
    this.referenceNumber = model.referenceNumber;
  }
}
